import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import OverflowMenu from '../../components/OverflowMenu';
import { Channel, fetchAllChannels } from '../../api';
import Spinner from '../../components/Spinner';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Channels = () => {
  const [data, setData] = useState<Channel[] | null>(null);

  useEffect(() => {
    fetchAllChannels().then((data) => {
      setData(data);
    });
  }, []);

  const columns = [
    { name: 'ID', selector: (row: Channel) => row.id ?? '', sortable: true, maxWidth: '40px' },
    { name: 'Name', selector: (row: Channel) => row.name, sortable: true, maxWidth: '180px' },
    { sortable: false, button: true, cell: (row: Channel) => <OverflowMenu type="channel" id={row.id} /> },
  ];

  return (
    <div className="ms-content-wrapper">
      <div className="ms-panel">
        <div className="ms-panel-header d-flex justify-content-between align-items-center">
          <h6>Channels</h6>
          <Link to={`/channel/add`}>
            <Button variant="primary">Add</Button>
          </Link>
        </div>
        <div className="ms-panel-body">
          {!data && <Spinner />}
          {data && (
            <div className="table-responsive datatables row">
              <DataTableExtensions {...{ columns, data }} export={false} print={false}>
                <DataTable columns={columns} data={data} pagination responsive={true} highlightOnHover noHeader />
              </DataTableExtensions>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Channels;
